import { Box, CardContent, CardMedia, LinearProgress } from '@mui/material'
import { useState } from 'react'
import { pallete } from '../../../theme'
import { isDefined } from '../../../utils'
import { Card, TranslatableTypography } from '../widgets'
import DefaultAchievementIcon from '../widgets/DefaultAchievementIcon'

const stylePrefix = 'CompanionVotingCard'

const votingCardStyle = {
  card: {
    width: '100%',
    height: '100%',
    position: 'relative',
    '& .voting-avatar': {
      visibility: 'hidden',
      position: 'absolute',
      top: '0px',
      left: '0px'
    },
    '&.loaded .voting-avatar': {
      visibility: 'visible'
    },
    '& .voting-avatar-loader': {
      position: 'absolute',
      top: '0px',
      left: '0px',
      width: '100%'
    },
    [`& .${stylePrefix}-wrapper`]: {
      position: 'absolute',
      display: 'inline-block',
      width: '100%',
      top: '0px',
      left: '0px',
      padding: '5px',
      textAlign: 'right'
    }
  },
  media: {
    width: '100%',
    height: 'calc(100% - 24px)',
    background: pallete.headerBrightColor,
    color: pallete.paperColor
  },
  defaultAvatar: {
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: '100%',
    height: '100%',
    '& .companion-voting-default-avatar': {
      width: '100%',
      height: '100%',
      background: pallete.headerBrightColor,
      color: pallete.paperColor,
      opacity: '0.3'
    },
    '& .companion-voting-default-avatar-background': {
      width: '100%',
      height: '100%',
      background: pallete.paperColor,
      position: 'absolute',
      top: '0px',
      left: '0px'
    }
  },
  content: {
    width: '100%',
    position: 'absolute',
    bottom: '0px',
    left: '0px',
    padding: '5px !important',
    background: pallete.headerColor,
    color: pallete.paperColor,
    textAlign: 'center',
    maxHeight: '64px',
    '& p': {
      fontSize: '14px',
      lineHeight: '14px',
      wordWrap: 'break-word'
    }
  }
}

const VotingCardScore = (props) => {
  const { data } = props
  const icons = data.length !== 0 ? <DefaultAchievementIcon data={data} /> : undefined
  return (
    <Box className={`${stylePrefix}-wrapper`}>
      {icons}
    </Box>
  )
}

export const VotingCard = (props) => {
  const customSx = props.sx ?? votingCardStyle.card
  const { votes, data } = props
  const { avatar_url, name, number } = data
  const scoreData = isDefined(votes) && isDefined(number) ? votes[number] ?? [] : []
  const [previousState, setPreviousState] = useState({
    loaded: false,
    error: false,
    previousAvatar: undefined
  })
  const { loaded, error, previousAvatar } = previousState
  const changed = previousAvatar !== avatar_url
  const loader = changed ? (<LinearProgress className="voting-avatar-loader"/>) : undefined
  const loadedClassName = loaded && !error ? 'loaded' : ''
  const noAvatar = (changed) || (loaded && error)
    ? (
      <Box
        sx={votingCardStyle.defaultAvatar}
        onClick={props.onClick}
      >
        <Box className="companion-voting-default-avatar-background" />
        <CardMedia component="img" className="companion-voting-default-avatar" image="/no_avatar.jpg"/>
      </Box>
      )
    : undefined
  const loading = (props?.loading ?? 'lazy')
  const errorHandler = () => {
    setPreviousState({
      loaded: true,
      error: true,
      previousAvatar: avatar_url
    })
  }
  const successHandler = () => {
    setPreviousState({
      loaded: true,
      error: false,
      previousAvatar: avatar_url
    })
  }
  return (
    <Card
      sx={customSx}
      className={loadedClassName}
    >
      <CardMedia
        component="img"
        className="voting-avatar"
        sx={{ ...votingCardStyle.media }}
        image={avatar_url}
        alt={name}
        loading={loading}
        onError={errorHandler}
        onLoad={successHandler}
        onClick={props.onClick}
      />
      <VotingCardScore data={scoreData}/>
      {noAvatar}
      {loader}
      <CardContent
        sx={votingCardStyle.content}
        onClick={props.onClick}
      >
        <TranslatableTypography>
          {name}
        </TranslatableTypography>
      </CardContent>
    </Card>
  )
}
